import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 32px;

  display: flex;
  flex-direction: column;
`